import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "home-paragraph__description" }, [
  /*#__PURE__*/_createTextVNode(" Повышенные баллы Газпром нефть, Wink, PREMIER, подписка Ozon Premium и другие сервисы всего за "),
  /*#__PURE__*/_createElementVNode("span", null, "1 ₽ на 60 дней"),
  /*#__PURE__*/_createTextVNode(" в подписке Газпром Бонус ")
], -1)
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-full",
  style: {"padding":"10px"}
}, " Реклама. ООО «Сеть партнерств». ИНН 9701161387, erid: 2VSb5xfpA8G ", -1)

import MetaDefault from "@/components/MetaDefault.vue";
import GazpromIcon from "@/components/pages/index/GazpromIcon.vue";
import ButtonDefault from "@/components/ButtonDefault.vue";
import HomeMenuDown from "@/components/pages/index/HomeMenuDown.vue";
import { redirectToWantUrl } from "@/utils/redirects";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(GazpromIcon, { class: "home-gazprom__icon" }),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ButtonDefault, {
            label: "Попробовать за 1₽",
            class: "home-button__want",
            onClick: _unref(redirectToWantUrl)
          }, null, 8, ["onClick"])
        ])
      ]),
      _createVNode(HomeMenuDown),
      _hoisted_5
    ]),
    _createVNode(MetaDefault, { title: "Главная" })
  ], 64))
}
}

})